import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import styles from "./SuggestedTerm.css";
import { withTranslation } from "../../translation/";
import { getSuggestTerms, isExactMatch } from "../../../state/modules/search";

const SuggestedTerm = ({ formatTranslation }) => {
  const exactMatch = useSelector(isExactMatch);
  const suggestedTerms = useSelector(getSuggestTerms);

  if (exactMatch) {
    return null;
  }

  return (
    <p className={styles.alternativeText}>
      {formatTranslation("plp_web_suggested_term_suggestion_alternative")}
      <span className={styles.suggestedTerm}>
        {formatTranslation("plp_web_suggested_term_search_used_term", {
          suggestedTerm: suggestedTerms[0]
        })}
      </span>
    </p>
  );
};

SuggestedTerm.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

SuggestedTerm.displayName = "SuggestedTerm";

export default withTranslation(SuggestedTerm);
